



























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "kpi",
})
export default class Kpi extends Vue {
    @Prop({ required: true })
    label!: string;

    @Prop({ required: true })
    value!: any;

    @Prop({ required: false })
    tooltip!: string;

    @Prop({ default: "white" })
    color!: any;

    @Prop()
    dataCy: string;
}
